import { AuthModel, UnitRequest } from '@gtpl/shared-models/common-models';
import { PoItemsResponseModel, PoNumbersResponseModel, PoDetailViewResponseModel, AllPoResponseModel, CreatePoResponse, UpdatePoResponseModel, GetAllPoResponse, PoDetailsForPoIdResponse, PoDataResponseModel, PoNumbersModel, PoReportRequest, PoReportResponseModel } from '@gtpl/shared-models/procurement-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Inject, Post } from '@nestjs/common';
import { REQUEST } from '@nestjs/core';
import { ApiTags } from '@nestjs/swagger';
import { PurchaseOrderDTO } from './dto/po-creation.dto';
import { PurchaseOrderIdRequest } from './dto/po-id.request';
import { SOVendorRequest } from './dto/sale-order-vendor.request';
import { PoCreationService } from './po-creation.service';
import { Request } from 'express';
import { PoDetailsDTO } from './dto/po-details-create.dto';
import { PoSaleIdRequest } from './dto/po-sale-id.request';
import { PoFilterData } from './dto/po-filters.dto';
import { POCloseRequest } from './dto/po-close-request';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { POItemIdRequest } from './dto/po-item-id.request';
import { BomIdsRequest } from './dto/bom-ids.request';
import { Cron } from '@nestjs/schedule';
import { PoQtyGrnDtoReqDto } from './dto/PoQtyGrnQty.dto';
import { VenndorIdReq } from './dto/vendor-id-req';
import { POSupplierStatus } from './dto/po-suppier-status-req';
import { PoStockrequest } from './dto/po-stock.request';
import { UnitIdRequest } from '../store-consumption/dto/unit-id.request';
@ApiTags('PoCreation')
@Controller('po-creation')
export class PoCreationController {
    constructor(private poServices: PoCreationService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
        // private authModel: AuthModel,
        // @Inject(REQUEST) private request: Request
    ) {
    }



    @Post('/CreatePo')
    async CreatePo(@Body() poData: PoDetailsDTO): Promise<CreatePoResponse> {
        try {
            return this.poServices.CreatePurchaseOrder(poData, false);
        } catch (error) {
            return error;
        }
    }

    @Post('/UpdatePo')
    async UpdatePo(@Body() poData: PoDetailsDTO) {
        try {
            return this.poServices.CreatePo(poData, true);
        } catch (error) {
            return error;
        }
    }
    /**
  * get PO against POId
  * @param poIdReq poIdReq
  * @returns GrnResponse
  */
    @Post('/getPoDataById')
    async getPoDataById(@Body() poIdReq: PurchaseOrderIdRequest): Promise<PoItemsResponseModel> {
        try {
            return await this.poServices.getPoDataById(poIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(PoItemsResponseModel, error);
        }
    }

    /**
* get PO Numbers
* @param 
* @returns GrnResponse
*/
    @Post('/getPoNumbers')
    async getPoNumbers(): Promise<PoNumbersResponseModel> {
        try {
            return await this.poServices.getPoNumbers();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(PoNumbersResponseModel, error);
        }
    }

    @Post('/getPoNumbersByVendor')
    async getPoNumbersByVendor(@Body() req: BomIdsRequest): Promise<PoNumbersResponseModel> {
        try {
            console.log('reqiii')
            console.log(req)
            return await this.poServices.getPoNumbersByVendor(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(PoNumbersResponseModel, error);
        }
    }




    //  @Post('/getPoDetailViewDataById')
    //  async getPoDetailViewDataById(@Body() poIdReq:PurchaseOrderIdRequest): Promise<PoDetailViewResponseModel> {
    //      try {
    //       //  const respo = this.poServices.getPODataById(poIdReq);
    //        console.log(poIdReq.purchaseOrderId +"....................")
    //       return await this.poServices.getPODataById(poIdReq);
    //     } catch (error) {
    //          return this.applicationExceptionHandler.returnException(PoDetailViewResponseModel , error);
    //     }
    //   }
    /**
 * get PO details 
 * @param 
 * @returns AllPoResponseModel
 */
    // @Post('/getAllPoDetails')
    // async getAllPoDetails(): Promise<AllPoResponseModel> {
    //     try {
    //     return await this.poServices.getAllPoDetails();
    //     } catch (error) {
    //             return this.applicationExceptionHandler.returnException(AllPoResponseModel, error);
    //     }
    // }

    /**
     * 
     * @param soVendorReq 
     * @returns get items against sale order and vendor
     */
    @Post('GetItemsForSaleOrderVendor')
    async GetItemsForSaleOrderVendor(@Body() soVendorReq: SOVendorRequest) {
        try {
            return await this.poServices.GetItemsForSaleOrderVendor(soVendorReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllPoResponseModel, error);
        }
    }

    /**
    * 
    * @param soVendorReq 
    * @returns get items against sale order and vendor
    */
    @Post('GetItemsForBomVendor')
    async GetItemsForBomVendor(@Body() soVendorReq: BomIdsRequest) {
        try {
            return await this.poServices.GetItemsForBomVendor(soVendorReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllPoResponseModel, error);
        }
    }

    /**
     * 
     * @param poIdReq 
     * @returns get po details for po id
     */
    @Post('GetPurchaseOrderDetailsForPoId')
    async GetPurchaseOrderDetailsForPoId(@Body() poIdReq: PurchaseOrderIdRequest): Promise<UpdatePoResponseModel> {
        try {
            console.log(poIdReq);
            return await this.poServices.GetPurchaseOrderDetailsForPoId(poIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(UpdatePoResponseModel, error);
        }
    }

    /**
     * 
     * @returns get all po details
     */
    @Post('getAllPoDetailsInfo')
    async getAllPoDetailsInfo(@Body() req?: PoFilterData): Promise<GetAllPoResponse> {
        try {
            return await this.poServices.getAllPoDetailsInfo(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GetAllPoResponse, error);
        }
    }

    /**
     * 
     * @param poIdReq 
     * @returns 
     */
    @Post('getPoDataDetailsForPoId')
    async GetPoDataDetailsForPoId(@Body() poIdReq: PurchaseOrderIdRequest): Promise<PoDetailsForPoIdResponse> {
        try {
            return await this.poServices.GetPoDataDetailsForPoId(poIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(PoDetailsForPoIdResponse, error);
        }
    }
    @Post('getPoDetailsForSaleId')
    async getPoDetailsForSaleId(@Body() poSaleIdRequest: PoSaleIdRequest): Promise<PoDataResponseModel> {
        try {
            return await this.poServices.getPoDetailsForSaleId(poSaleIdRequest);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(PoDataResponseModel, error);
        }
    }

    @Post('/getPoNumberById')
    async getPoNumberById(@Body() poIdReq: PurchaseOrderIdRequest): Promise<PoNumbersModel> {
        try {
            return await this.poServices.getPoNumberById(poIdReq.purchaseOrderId);
        } catch (error) {
            return error;
        }
    }


    @Post('/getPoDetailReport')
    async getPoDetailReport(@Body() req?: PoReportRequest): Promise<CommonResponse> {
        try {
            return await this.poServices.getPoDetailReport(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getItemSubDropForPoReport')
    async getItemSubDropForPoReport(@Body() req?: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.poServices.getItemSubDropForPoReport(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getPurchaseOrdersForReport')
    async getPurchaseOrdersForReport(@Body() req?: PoReportRequest): Promise<PoReportResponseModel> {
        try {
            return await this.poServices.getPurchaseOrdersForReport(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(PoReportResponseModel, error);
        }
    }
    @Post('/getPoNumber')
    async getPoNumber(): Promise<PoNumbersResponseModel> {
        try {
            return await this.poServices.getPoNumber();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(PoNumbersResponseModel, error);
        }
    }

    @Post('/closePOManually')
    async closePOManually(@Body() poIdReq: POCloseRequest): Promise<CommonResponse> {
        try {
            return await this.poServices.closePOManually(poIdReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/deletePoItem')
    async deletePoItem(@Body() req: POItemIdRequest): Promise<CommonResponse> {
        try {
            return await this.poServices.deletePoItem(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getPoItemDetailsForSaleId')
    async getPoItemDetailsForSaleId(@Body() req: PoSaleIdRequest): Promise<CommonResponse> {
        try {
            return await this.poServices.getPoItemDetailsForSaleId(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }




    @Post('/getCancelledSosForPo')
    async getCancelledSosForPo(): Promise<CommonResponse> {
        try {
            return await this.poServices.getCancelledSosForPo();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/ClosePoForCancelledSo')
    async ClosePoForCancelledSo(@Body() poIdReq: POCloseRequest): Promise<CommonResponse> {
        try {
            return await this.poServices.ClosePoForCancelledSo(poIdReq.purchaseOrderId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/CancelPoForCancelledSo')
    async CancelPoForCancelledSo(@Body() poIdReq: POCloseRequest): Promise<CommonResponse> {
        try {
            return await this.poServices.CancelPoForCancelledSo(poIdReq.purchaseOrderId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    /**
     * 
     * @returns get all po details
     */
    @Post('getCancelledPosData')
    async getCancelledPosData(@Body() req?: PoFilterData): Promise<GetAllPoResponse> {
        try {
            return await this.poServices.getCancelledPosData(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GetAllPoResponse, error);
        }
    }

    /**
    * 
    * @returns get all revised sos, po details
    */
    @Post('getRevisedSos')
    async getRevisedSos(@Body() req?: PoFilterData): Promise<GetAllPoResponse> {
        try {
            return await this.poServices.getRevisedSos(req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GetAllPoResponse, error);
        }
    }

    @Post('getTransferredSos')
    async getTransferredSos(): Promise<GetAllPoResponse> {
        try {
            return await this.poServices.getTransferredSos();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GetAllPoResponse, error);
        }
    }
    @Post('getPoUsage')
    async getPoUsage(): Promise<any> {
        try {
            return await this.poServices.getPoUsage();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error)
        }
    }

    @Post('getSoDropForPoReport')
    async getSoDropForPoReport(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.poServices.getSoDropForPoReport(req);
        } catch (error) {
            return error;
        }
    }
    @Post('getPoDropForPoReport')
    async getPoDropForPoReport(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.poServices.getPoDropForPoReport(req);
        } catch (error) {
            return error;
        }
    }
    @Post('getVendorDropForPoReport')
    async getVendorDropForPoReport(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.poServices.getVendorDropForPoReport(req);
        } catch (error) {
            return error;
        }
    }
    @Post('getItemDropForPoReport')
    async getItemDropForPoReport(@Body() req: UnitRequest): Promise<CommonResponse> {
        try {
            return await this.poServices.getItemDropForPoReport(req);
        } catch (error) {
            return error;
        }
    }
    @Cron('* 1 * * *')
    @Post('PoLifeCycleStatus')
    async PoLifeCycleStatus(): Promise<CommonResponse> {
        try {
            return await this.poServices.PoLifeCycleStatus();
        } catch (error) {
            return error;
        }
    }
    @Post('/getPoLifeCycleStatusCount')
    async getPoLifeCycleStatusCount(): Promise<any> {
      try {
        return await this.poServices.getPoLifeCycleStatusCount();
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }
    @Post('/getPoLifeStatus')
    async getPoLifeStatus(@Body() req: UnitRequest): Promise<CommonResponse> {
      try {
        return await this.poServices.getPoLifeStatus(req);
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }
    @Post('/getPoDeadStock')
    async getPoDeadStock(@Body() req: UnitRequest) :Promise<CommonResponse> {
        try {
            return await this.poServices.getPoDeadStock(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getPoSubCategory')
    async getPoSubCategory (@Body() req: UnitRequest):Promise<CommonResponse>{
        try{
            return await this.poServices.getPoSubCategory(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getSoWiseQty')
    async getSoWiseQty (@Body() req: UnitRequest):Promise<CommonResponse>{
        try{
            return await this.poServices.getSoWiseQty(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getDummyWiseQty')
    async getDummyWiseQty (@Body() req: UnitRequest):Promise<CommonResponse>{
        try{
            return await this.poServices.getDummyWiseQty(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/fastMovingProd')
    async fastMovingProd (@Body() req: UnitRequest):Promise<CommonResponse>{
        try{
            return await this.poServices.fastMovingProd(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getPoLifeCycleStatus')
    async getPoLifeCycleStatus (@Body() req:UnitRequest):Promise<CommonResponse>{
        try{
            return await this.poServices.getPoLifeCycleStatus(req);
        }
        catch (error){
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }
    @Post('/getSkippedPoCount')
    async getSkippedPoCount(): Promise<any> {
      try {
        return await this.poServices.getSkippedPoCount();
      } catch (error) {
        return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
    }
    @Post('/getPoQtyGrnQty')
    async getPoQtyGrnQty(@Body() dtoObj: PoQtyGrnDtoReqDto): Promise <CommonResponse> {
        try {
            return await this.poServices.getPoQtyGrnQty(dtoObj);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getPoDataForVendor')
    async getPoDataForVendor(@Body() dtoObj: VenndorIdReq): Promise <CommonResponse> {
        try {
            return await this.poServices.getPoDataForVendor(dtoObj);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/updateSupplierStatus')
    async updateSupplierStatus(@Body() req: POSupplierStatus): Promise <CommonResponse> {
        try {
            return await this.poServices.updateSupplierStatus(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getPoItemsDataForVendor')
    async getPoItemsDataForVendor(@Body() dtoObj: VenndorIdReq): Promise <CommonResponse> {
        try {
            return await this.poServices.getPoItemsDataForVendor(dtoObj);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getOpenPoNumbersForVendor')
    async getOpenPoNumbersForVendor(@Body() dtoObj: VenndorIdReq): Promise <CommonResponse> {
        try {
            return await this.poServices.getOpenPoNumbersForVendor(dtoObj);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getPackingStockData')
    async getPackingStockData(@Body()req:PoStockrequest ): Promise <CommonResponse> {
        try {
            return await this.poServices.getPackingStockData(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }

    @Post('/getItemSubCatForPackingStock')
    async getItemSubCatForPackingStock(@Body()req:UnitIdRequest ): Promise <CommonResponse> {
        try {
            return await this.poServices.getItemSubCatForPackingStock(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getPoNumForPackingStock')
    async getPoNumForPackingStock( @Body()req:UnitIdRequest ): Promise <CommonResponse> {
        try {
            return await this.poServices.getPoNumForPackingStock(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getSupplyPerformanceReport')
    async getSupplyPerformanceReport(@Body() req:PoStockrequest): Promise <CommonResponse> {
        try {
            return await this.poServices.getSupplyPerformanceReport(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getItemSubCatForStockPerformance')
    async getItemSubCatForStockPerformance( @Body()req:UnitIdRequest ): Promise <CommonResponse> {
        try {
            return await this.poServices.getItemSubCatForStockPerformance(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getVendorsForSupplyPerformance')
    async getVendorsForSupplyPerformance( @Body()req:UnitIdRequest ): Promise <CommonResponse> {
        try {
            return await this.poServices.getVendorsForSupplyPerformance(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    @Post('/getItemsForSupplyPerformance')
    async getItemsForSupplyPerformance( @Body()req:UnitIdRequest ): Promise <CommonResponse> {
        try {
            return await this.poServices.getItemsForSupplyPerformance(req);
        } catch (Error) {
            // throw Error;
            return this.applicationExceptionHandler.returnException(CommonResponse, Error);
        }
    }
    // @Post('/StockmigUpdate')
    // async StockmigUpdate(): Promise <boolean> {
    //     try {
    //         return await this.poServices.StockmigUpdate();
    //     } catch (Error) {
    //         throw Error;
    //         // return this.applicationExceptionHandler.returnException(CommonResponse, Error);
    //     }
    // }
    
}
